/**
 * An href we are willing to put in front of a person.
 *
 * A meeting link normally comes back from the provider, but the `manual`
 * provider lets an admin paste one in, and React will happily render a
 * `javascript:` href. Checking the scheme costs nothing and closes that off.
 */
export function httpsUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}
